const API_URL = `${process.env.REACT_APP_URL_API}${process.env.REACT_APP_PATH_REPORTES}`;


//obtener todas las denuncias
export const getReporte = async ({ token }) => {
    try {
        const response = await fetch(API_URL, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        });
        if (!response.ok) {
            throw new Error('Error al obtener las denuncias');
        }
        const data = await response.json();
        //ordenar del id mas grande al mas pequeño
        data.sort((a, b) => b.id - a.id);
        return data;
    }
    catch (error) {
        throw error;
    }
};

//obtener denuncias por usuario id
export const getReportesByUserID = async ({ token, userID }) => {
    try {
        const url = `${API_URL}/user/${userID}`;
        //console.log(url);
        //console.log(token);
        const response = await fetch(url, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        });
        if (!response.ok) {
            throw new Error('Error al obtener usuario');
        }
        const data = await response.json();
        //ordenar del id mas grande al mas pequeño
        data.sort((a, b) => b.id - a.id);
        return data;
    }
    catch (error) {
        throw error;
    }
};

//crear una denuncia
export const createReporte = async ({ token, formData }) => {
    try {
        const response = await fetch(API_URL, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
            body: formData,
        });

        if (!response.ok) {
            throw new Error('Error al crear la denuncia');
        }

        return await response.json();
    } catch (error) {
        throw error;
    }
};

//cambiar estatus a una denuncia
export const updateReporteEstatus = async ({ token, denuncia }) => {
    try {
        const response = await fetch(`${API_URL}/${denuncia.id}`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(denuncia),
        });
        if (!response.ok) {
            throw new Error('Error al actualizar la denuncia');
        }
        //console.log("se actualizo la denuncia correctamente");
        return await response.json();
    } catch (error) {
        console.error('Error al actualizar la denuncia:', error);
        throw error;
    }
};